<div class="reale-theme-style1 fs-6" fxLayout="column" fxLayoutGap="2rem">
  <header [configuration]="headerConfiguration"></header>

  <div fxLayout="column">
    <div class="title" fxLayout="row" fxLayoutAlign="start center">
      <div class="avatar">
        
      </div>
      <div *ngIf="!!user" fxLayout="column">
        <div class="userName">{{user.name}}</div>
        <div class="userEmail">{{user.username}}</div>
      </div>
    </div>

    <div class="page" fxLayout="row">
      <div class="sidebar" fxLayout="column" fxLayoutAlign="space-between center" >
        <div fxLayout="column" fxLayoutAlign="start center">
          <div class="sidebar-button" fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="{active: option === 'userData'}" (click)="selectTab('userData')">
            <div class="sidebar-button-text">{{'profile.sidebarButtonText.userData' | translate}}</div>
            <div class="sidebar-button-icon"><mat-icon [svgIcon]="'user'"></mat-icon></div>
          </div>
          <div class="divider"></div>
          <div *ngIf="isAdmin" class="sidebar-button" fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="{active: option === 'profileConfig'}" (click)="selectTab('profileConfig')">
            <div class="sidebar-button-text">{{'profile.sidebarButtonText.profileConfig' | translate}}</div>
            <div class="sidebar-button-icon"><mat-icon [svgIcon]="'settings'"></mat-icon></div>
          </div>
          <div *ngIf="isAdmin" class="divider"></div>
          <div class="sidebar-button" fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="{active: option === 'help'}" (click)="selectTab('help')">
            <div class="sidebar-button-text">{{'profile.sidebarButtonText.help' | translate}}</div>
            <div class="sidebar-button-icon"><mat-icon [svgIcon]="'help'"></mat-icon></div>
          </div>
        </div>

        <div class="logout-button" fxLayout="row" fxLayoutAlign="space-between center" (click)="logout()">
          <div class="logout-text">{{'profile.userDataLabels.logout' | translate}}</div>
          <div class="logout-icon"><mat-icon [svgIcon]="'rigth-down-pink-arrow'"></mat-icon></div>
        </div>
      </div>
      <div class="content">
        <div [ngSwitch]="option">
        <div *ngSwitchCase="'userData'">
          <div class="content-title">{{'profile.sidebarButtonText.userData' | translate}}</div>
            <form class="form" [formGroup]="userForm">
              <div class="form-field">
                <label class="form-label" for="marca">
                    {{'profile.userDataLabels.name' | translate}}
                </label>
                <input [value]="userForm.controls['name'].value" class="form-input" id="marca" type="text" formControlName="name" readonly>
              </div>
              <div class="form-field">
                <label class="form-label" for="marca">
                  {{'profile.userDataLabels.surname' | translate}}
                </label>
                <input [value]="userForm.controls['surname'].value" class="form-input" id="marca" type="text" formControlName="surname" readonly>
              </div>
              <div class="form-field">
                <label class="form-label" for="marca">
                  {{'profile.userDataLabels.email' | translate}}
                </label>
                <input [value]="userForm.controls['email'].value" class="form-input" id="marca" type="text" formControlName="email" readonly>
              </div>
            </form>
            <!-- Boton de solicitar nueva contraseña, ocultado por no salir la funcionalidad en el alcance del MVP 1 -->
            <!-- <div class="change-password-button" fxLayout="row" fxLayoutAlign="center center">
              <div class="change-password-text">{{'profile.userDataLabels.newPassword' | translate}}</div>
            </div> -->
          <div>
          </div>
        </div>
        <div *ngSwitchCase="'profileConfig'">
          <div class="content-title">{{'profile.sidebarButtonText.profileConfig' | translate}}</div>
        </div>
        <div *ngSwitchCase="'help'">
          <div class="content-title">{{'profile.sidebarButtonText.help' | translate}}</div>
          <div class="contact-card" fxLayout="column">
            <div class="contact-header" fxLayout="row">
              <div class="contact-icon">
                <div class="sidebar-button-icon"><mat-icon [svgIcon]="'question-mark'"></mat-icon></div>
              </div>
              <div class="contact-title">
                {{'profile.helpLabels.needHelp' | translate}}
              </div>
              <div class="contact-subtitle">
                {{'profile.helpLabels.contactWithUs' | translate}}
              </div>
            </div>
            <div class="contact-content" fxLayout="row" fxLayoutAlign="center center">
              <!-- <div class="contact-info" fxLayout="row" fxLayoutAlign="start center">
                <div class="contact-icon"><mat-icon [svgIcon]="'pink-phone'"></mat-icon></div>
                <div class="contact-data">{{phone}}</div>
              </div>
              <div class="contact-info" fxLayout="row" fxLayoutAlign="start center">
                <div class="contact-icon"><mat-icon [svgIcon]="'pink-whatsapp'"></mat-icon></div>
                <div class="contact-data">{{whatsApp}}</div>
              </div> -->
              <div class="contact-info" fxLayout="row" fxLayoutAlign="start center">
                <div class="contact-icon"><mat-icon [svgIcon]="'pink-email'"></mat-icon></div>
                <div class="contact-data">{{ingoodEmail}}</div>
              </div>
            </div>
          </div>

          <div class="dropdowns">
            <div *ngFor="let drop of dropdowns">
              <app-dropdown-info [title]="drop.title" [paragraphs]="drop.descripcion"></app-dropdown-info>
            </div>
          </div>

        </div>
        <div *ngSwitchDefault>
        </div>
        </div>
      </div>
    </div>

  </div>

</div>